module.exports = __webpack_public_path__ + "static/media/menuheader-min.ba07c2aa.png";